// Single source of truth for the /faq (Регламент) page.
//
// Consumed by both src/pages/Faq.jsx (what renders) and
// src/components/SEO/FaqSEO.jsx (the ItemList structured data), so the markup
// cannot drift away from the visible content.
//
// `active: false` renders the entry dimmed (past or not-yet-open series).

export const regulations = [
  {
    name: "Formula 4 Series 2026",
    url: "https://docs.google.com/document/d/e/2PACX-1vRD3viLY4cY5e4VOwe8vYbbkq4AMV5D3XbQPCX_eCQhndaARARmNKJtpdh9gUFBaCjpw7mm7cv0jArJ/pub",
    active: true,
  },
  {
    name: "Formula Invitational 2026",
    url: "https://docs.google.com/document/d/e/2PACX-1vSSeWaFYCqPzfoqJwAXgkvCN-YN_MF-gn9D7KIsk--eXWUUfBv49oDhk9-WiRKO3l9g3n4or6Qxpxn6/pub",
    active: false,
  },
  {
    name: "Super Formula Lights Series 2026",
    url: "https://docs.google.com/document/d/e/2PACX-1vRcw1xfyY8_ErNCsijV324SyD6B0ZAQ29hL4HBPCutTxCCEMeo3OYjs2BabUiHT6C8Bt3Kzoz4gfogu/pub",
    active: false,
  },
];

export default regulations;
